export interface GTMNoScriptProps {
  /**
   * GTM Container ID.
   */
  gtmId: string
}

/**
 * Google Tag Manager NoScript component
 * Fallback for users with JavaScript disabled.
 * SuppressHydrationWarning is used to prevent hydration errors when this component
 * is conditionally rendered based on feature flags that aren't available on server.
 */
export const GTMNoScript: React.FC<GTMNoScriptProps> = ({ gtmId }) => {
  return (
    <noscript suppressHydrationWarning>
      <iframe
        height="0"
        src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
        style={{ display: 'none', visibility: 'hidden' }}
        title="Google Tag Manager"
        width="0"
      />
    </noscript>
  )
}
